export default "__VITE_PUBLIC_ASSET__ec5a075a__"